import { render, staticRenderFns } from "./store-admin-detail.vue?vue&type=template&id=6646459a&scoped=true&"
import script from "./store-admin-detail.vue?vue&type=script&lang=js&"
export * from "./store-admin-detail.vue?vue&type=script&lang=js&"
import style0 from "./store-admin-detail.vue?vue&type=style&index=0&id=6646459a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6646459a",
  null
  
)

export default component.exports